import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13 4.65996V2.65996C12.9952 2.51168 13.0622 2.37019 13.18 2.27996C13.288 2.18101 13.4353 2.13682 13.58 2.15996C17.8502 2.84109 21.1989 6.18975 21.88 10.46C21.9031 10.6046 21.8589 10.7519 21.76 10.86C21.6698 10.9777 21.5283 11.0447 21.38 11.04H19.38C19.1424 11.04 18.9375 10.8728 18.89 10.64C18.3355 7.86977 16.1702 5.70443 13.4 5.14996C13.1672 5.10243 12.9999 4.89759 13 4.65996ZM16.48 17.9C16.3128 17.7288 16.0465 17.7035 15.85 17.84C14.7103 18.6003 13.37 19.0041 12 19C8.42227 18.9791 5.43609 16.2637 5.07627 12.7041C4.71645 9.14443 7.09882 5.88636 10.6 5.14996C10.8328 5.10243 11 4.89759 11 4.65996V2.65996C11.0048 2.51168 10.9378 2.37019 10.82 2.27996C10.712 2.18101 10.5647 2.13682 10.42 2.15996C6.35295 2.8333 3.11589 5.93339 2.26745 9.96754C1.41901 14.0017 3.13308 18.1431 6.58434 20.3976C10.0356 22.6522 14.5167 22.5578 17.87 20.16C17.9848 20.0695 18.0572 19.9356 18.07 19.79C18.0819 19.6458 18.0309 19.5036 17.93 19.4L16.48 17.9ZM21.38 13H19.38C19.1424 12.9999 18.9375 13.1671 18.89 13.4C18.7247 14.2755 18.3846 15.1088 17.89 15.85C17.7576 16.0475 17.7827 16.3109 17.95 16.48L19.4 17.93C19.5036 18.0308 19.6459 18.0819 19.79 18.07C19.938 18.0572 20.0731 17.9805 20.16 17.86C21.0713 16.5884 21.677 15.1238 21.93 13.58C21.9531 13.4353 21.9089 13.288 21.81 13.18C21.7099 13.0464 21.5454 12.9775 21.38 13Z"
      fill={props.color || 'currentColor'}
    />
  </svg>
);
const SvgChartDonut = (props: IconProps) => (
  <SVGUniqueID>{Icon(props)}</SVGUniqueID>
);
export default SvgChartDonut;
